<template>
  <el-popover placement="bottom" trigger="manual" width="350px" v-model="truck">
    <i class="el-icon-location-information"></i>
    <i class="el-icon-office-building right"></i>
    <i class="fa fa-truck" style="margin-left: 80px"></i>
    <el-progress :percentage="percentage" :show-text="false"></el-progress>
    <span>Tempo estimado: <b>{{ estimateAt }}</b></span>&nbsp;
    <span class="right">Horário chegada: <b>{{ previousAt }}</b></span>
    <br />
    <br />
    <el-button type="primary" style="margin-right: 10px;" @click="truck = false">OK</el-button>
    <i
      v-show="show"
      class="fa fa-truck tag-icon header-info__icon"
      @click="truck = true"
      style="cursor: pointer; line-height: 60px;"
      slot="reference"
      aria-hidden="true"></i>
  </el-popover>
</template>
<script>
import { RouteService } from "@/services/umov/route.services";

export default {
  name: "TruckIcon",
  data() {
    return {
      truck: false,
      show: false,
      percentage: 30,
      estimateAt: "",
      previousAt: "",
    }
  },
  methods: {
    fetch() {
      const vm = this;
      console.log('route customer');
      RouteService.customer()
        .then((response) => {
          if (response.previousAt) {
            vm.show = true;
            vm.estimateAt = response.estimateAt;
            vm.previousAt = response.previousAt;
          }
        })
        .catch((error) => {
          vm.show = false;
        });
    },
  },
  mounted() {
    this.fetch();
  }
}
</script>
